<template>
  <div class="apply-page-wrap">
    <div class="apply-page-container">
      <!-- <div class="apply-title">歡迎申請入駐nicee平台，目前我們僅支持已認證陪玩師入駐本平台。全面註冊即將開放，敬請期待！</div> -->
      <div class="apply-main disabled">
        <div class="left">
          <!-- <img src="~@/assets/images/transfer-mini.png" alt=""> -->
          <div>
            <h3>{{$t('upgrade_page_views_apply_index_2005')}}</h3>
            <p>{{$t('upgrade_page_views_apply_index_2006')}}</p>
          </div>
        </div>
        <div class="right">
          <img src="~@/assets/images/activity-end-icon.png" alt="">
        </div>
      </div>
      <div class="apply-main">
        <div class="left">
          <!-- <img src="~@/assets/images/transfer-mini.png" alt=""> -->
          <div>
            <h3>{{$t('upgrade_page_layout_header_9')}}</h3>
            <p>{{$t('upgrade_page_views_apply_index_2007')}}</p>
          </div>
        </div>
        <div class="right">
          <!-- <img src="~@/assets/assets/activity-end-icon.png" alt=""> -->
        </div>
      </div>
      <div class="apply-footer">
        <p @click="checkLogin">
          <span>{{$t('upgrade_page_views_apply_index_2008')}}</span>
          <fps-icon class="arrow-icon" type="arrow-right" />
        </p>
      </div>
    </div>
  </div>
</template>

<script>
import { mapGetters } from 'vuex'

export default {
  computed: {
    ...mapGetters(['userInfo'])
  },
  data() {
    return {
    }
  },
  methods: {
    checkLogin() {
      if (this.userInfo) {
        this.openChat()
      } else {
        this.$util.Login().then(() => {
          this.openChat()
        })
      }
    },
    openChat() {
      this.$util.openChatWindow(this.userInfo.uuid)
    }
  }
}
</script>

<style lang="scss" scoped>
  .apply-page-wrap {
    width: 100%;
    padding-top: 40px;
    padding-bottom: 340px;
    background: #E5E5E5;
  }

  .apply-page-container {
    width: 1200px;
    margin: auto;
  }

  .apply-title,
  .apply-main {
    background: white;
    border-radius: 8px;
  }

  .apply-title {
    @include flex(flex-start);
    font-size: 16px;
    line-height: 22px;
    color: #333;
    height: 80px;
    padding: 0 40px;
  }

  .apply-main {
    @include flex(flex-start);
    height: 160px;
    margin-top: 20px;
    padding: 12px 40px;

    &.disabled {
      .left {
        opacity: 0.6;
      }
    }

    .left {
      @include flex();

      img {
        width: 168px;
        height: 76px;
        margin-right: 40px;
      }

      h3 {
        color: #333;
        font-size: 22px;
        line-height: 31px;
      }

      p {
        color: #666;
        font-size: 16px;
        line-height: 22px;
        margin-top: 8px;

        span {
          color: #FA006E;
        }
      }
    }

    .right {
      margin-left: 27px;

      img {
        width: 154px;
        height: 138px;
        opacity: 0.8;
      }
      // button {
      //   width: 164px;
      //   height: 46px;
      //   color: #FA006E;
      //   font-size: 16px;
      //   line-height: 16px;
      // }
    }
  }

  .apply-footer {
    margin-top: 30px;
    color: #666;
    font-size: 16px;
    line-height: 22px;
    text-align: center;

    p {
      @include flex();
      width: 430px;
      margin: auto;
      cursor: pointer;
    }
    .arrow-icon {
      font-size: 14px;
      margin-left: 4px;
      color: #666;
    }
  }

  .qr-code-dialog {

    & /deep/ .el-dialog__header {
      padding: 0;
    }

    & /deep/ .el-dialog__body {
      width: 418px;
      height: 475px;
      padding: 0;
      border-radius: 8px;
      background: white;
    }

    h3 {
      @include flex(space-between);
      height: 60px;
      padding: 0 18px 0 30px;
      font-size: 18px;
      font-weight: 500;
      line-height: 25px;
      
      img {
        width: 24px;
        height: 24px;
        cursor: pointer;
      }
    }

    .dilog-body {
      border-top: 1px solid #ECECEC;

      img {
        display: block;
        width: 250px;
        height: 250px;
        margin: 30px auto;
      }

      p {
        text-align: center;

        &:nth-child(2) {
          font-size: 18px;
          font-weight: 500;
          line-height: 25px;
          color :#333;
          margin-bottom: 10px;
        }

        &:last-child {
          margin-bottom: 0;
          color: #999;
          font-size: 14px;
          line-height: 20px;
        }
      }
    }
  }
</style>